import DocumentationButton from "components/DocumentationButton";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerFooter from "ds/components/Drawer/Footer";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import Typography from "ds/components/Typography";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { getDocsUrl } from "utils/getDocsUrl";

const ApiKeyGroupMappingInfoDrawer = createDrawer(() => {
  return (
    <DrawerSimple isDismissable>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Group mapping" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody fullHeight>
        <Typography tag="p" variant="p-body2">
          This screen shows how your API key is linked to group-based access.
          <br />
          <br />
          Spacelift supports two strategies for group-based access control:
          <ul>
            <li>Identity Access Management: Uses IdP group assignments.</li>
            <li>Login Policies: Uses group string mappings defined in Rego.</li>
          </ul>
          When using IAM strategy, use this view to verify whether your key is correctly mapped:
          <ul>
            <li>Mapped means the key's group is valid under IAM.</li>
            <li>
              Unmapped means it won't apply; access won't be enforced unless you update the
              configuration.
            </li>
          </ul>
          Use this as a validation layer to catch misconfigurations when switching between access
          models.
        </Typography>
        <DrawerFooter>
          {/** TODO: update docs link once we have updated documentation */}
          <DocumentationButton
            label="Documentation"
            to={getDocsUrl("/integrations/api#authenticating-with-the-graphql-api")}
            analyticsPage={AnalyticsPageOrganization.OrganizationApiKeys}
          />
        </DrawerFooter>
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showApiKeyGroupMappingInfoDrawer = createDrawerTrigger(ApiKeyGroupMappingInfoDrawer);
